import React, { useEffect } from "react";
import "./ScrollImg.css";

import w1 from "../../Assets/project15/w1.webp";
import w2 from "../../Assets/project15/w2.webp";
import w3 from "../../Assets/project15/w3.webp";
import w4 from "../../Assets/project15/w4.webp";
import w5 from "../../Assets/project15/w5.webp";
import w6 from "../../Assets/project15/w6.webp";
import w7 from "../../Assets/project15/w7.webp";
import w8 from "../../Assets/project15/w8.webp";
import w9 from "../../Assets/project15/w9.webp";
import w10 from "../../Assets/project15/w10.webp";
import w11 from "../../Assets/project15/w11.webp";


const ScrollImg15 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [w1, w2, w3, w4, w5, w6, w7, w8, w9, w10, w11];

  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg15;
